import React from "react"
import { Typography } from "@material-ui/core"
import TrendingTopicRow from "../TrendingTopicRow"

const TopicTable = ({ loading, data, maximums, activeView, onRowClick, width, classes }) => {
  if (loading) {
    return (
      <div className={classes.container}>
        <Typography style={{ textAlign: "center" }}>Loading...</Typography>
      </div>
    )
  }

  if (data.length === 0) {
    return (
      <div className={classes.container}>
        <Typography style={{ textAlign: "center" }}>No Data Available</Typography>
      </div>
    )
  }

  return (
    <div className={classes.container}>
      {data.map(d => (
        <div key={`trending-row-${d.id}-${activeView}`} className={classes.rowContainer}>
          <TrendingTopicRow
            id={d.id}
            label={d.label}
            values={d.values}
            maxValues={maximums}
            onClick={onRowClick}
            width={width}
          />
        </div>
      ))}
    </div>
  )
}

export default TopicTable
